export const feeAgreeOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];
